/**
 * The address for the Faucet contract. Useful for lobbies.
 */
export const FAUCET_ADDRESS = '0x1754653aEF244ACD24f16a940875e83E4f0e021C';
